import React, { Component } from 'react';
import { CardDeck, Card, CardHeader, CardBody} from 'reactstrap';

import withApp from './app';
import Actions from '../components/actions';
import Messages from '../components/messages';
import Organizations from '../components/organizations';
import T from 'modules/i18n';
import '../../scss/style.scss';

class AppDashboard extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isMessageModalOpen: false,
			activeMessageContent: {},
            activeProfile: '',
		};
	}

    handleOrganizationsProps = (orgProps) => {
        // Update state with received appProfile and optionally membership
        if (orgProps.appProfile !== this.state.activeProfile) {
            this.setState({
                activeProfile: orgProps.appProfile
            });
        }
    };

	render() {
		return (
			<>
				<div className="app-dashboard d-none d-md-block full-content py-3 px-5">
					<CardDeck className="mb-4 h-50">
						<Card className="dashboard-card mh-100">
							<CardHeader className="text-info fw-semibold"><T>actions</T></CardHeader>
							<CardBody className="d-flex justify-content-start py-xxl-4">
								<Actions/>
							</CardBody>
						</Card>
						<Card className="dashboard-card mh-100">
							<CardHeader className="text-info fw-semibold"><T>relevant organizations</T></CardHeader>
							<CardBody>
                            <Organizations
                                    sendOrganizationsProps={this.handleOrganizationsProps}
                                />
							</CardBody>
						</Card>
					</CardDeck>
					<CardDeck className="h-50">
						<Card className="dashboard-card mh-100">
							<CardHeader className="text-info fw-semibold"><T>new application</T></CardHeader>
							<CardBody className="justify-content-start">
								<Actions applications={true}/>
							</CardBody>
						</Card>

						<Card className="dashboard-card mh-100">
						<CardHeader className="text-info fw-semibold"><T>messages</T></CardHeader>
							<CardBody className="justify-content-start">
							<Messages
                            activeProfile={this.state.activeProfile}
                            dispatch={this.props.dispatch}
                            pending={this.props.pending}
                        />
							</CardBody>
						
						</Card>
					</CardDeck>
				</div>
			</>
		);
	}
}

export default withApp(AppDashboard);
